export class Clarification {
  id: number;
  title: string;
  imgUrl: string;
  questionId: number;
  companyId: number;
  additionalClarifications: Clarification[];
}
